import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagramSquare,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import LogoDark from "../assets/Logo.png";
import LogoLight from "../assets/Logo.png";

const Footer = () => {
  return (
    <footer className="bg-yellow-600 dark:bg-[radial-gradient(circle_at_center,_#1A2A4D_0%,_#0C0F16_80%)] text-white px-4 py-8 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24 justify-between">
          {/* Logo + About */}
          <div className="flex-1">
            <Link to="/" className="flex flex-row items-center lg:items-start">
              <img
                src={LogoLight}
                alt="MEDV logo light"
                className="block dark:hidden h-20"
              />
              <img
                src={LogoDark}
                alt="MEDV logo dark"
                className="hidden dark:block h-20"
              />
              <h2 className="text-3xl text-white pt-0 md:pt-5 font-semibold">MEDV Token</h2>
            </Link>
            <p className="text-sm sm:text-base text-center lg:text-left text-gray-100 mt-4 max-w-md">
              MEDV is transforming healthcare credentialing with blockchain, smart contracts, and token-driven incentives for real-time, secure, and compliant credential management.
            </p>
          </div>

          {/* Links + Contact */}
          <div className="flex flex-col sm:flex-row gap-12 justify-between flex-1 text-center sm:text-left">
            {/* Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4 text-white">Explore</h3>
              <ul className="space-y-2">
                {[
                  ["About", "/"],
                  ["Token", "/"],
                  ["Services", "/"],
                  ["Resources", "/"],
                ].map(([label, href]) => (
                  <li key={label}>
                    <Link to={href} className="text-sm hover:underline text-gray-200">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-lg font-semibold mb-4 text-white">Contact Us</h3>
              <div className="flex items-center justify-center sm:justify-start gap-2 mb-2">
                <Mail className="w-5 h-5" />
                <p className="text-sm">info@medvtoken.com</p>
              </div>
              <div className="flex items-center justify-center sm:justify-start gap-2">
                <Phone className="w-5 h-5" />
                <p className="text-sm">+1 310 927 8318</p>
              </div>
            </div>
          </div>
        </div>

        {/* Social Icons */}
        <div className="mt-8 flex justify-center lg:justify-start gap-4">
          <Link to="https://www.facebook.com/share/16oVyXWztB/?mibextid=wwXIfr">
            <FaFacebookF className="text-white text-2xl" />
          </Link>
          <Link to="https://x.com/Medvtoken?t=R-gyx4yZq9qhJXhiNQCtgQ&s=09">
            <FaTwitter className="text-white text-2xl" />
          </Link>
          {/* Add others when needed */}
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 dark:border-gray-700 mt-8 mb-4"></div>

        {/* Bottom Section */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-sm text-center">
          <p className="text-white dark:text-gray-400">
            &copy; {new Date().getFullYear()} MEDV. All rights reserved.
          </p>
          <div className="space-x-2 text-white dark:text-gray-400">
            <span>Terms & Conditions</span> | <span>Privacy Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
